var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneTwilio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03907 6.10352e-05C0.909074 6.10352e-05 -0.0309261 0.940374 0.0390739 2.07037C0.304074 6.33937 2.14343 10.1786 4.98243 13.0176C7.82143 15.8566 11.6607 17.696 15.9297 17.961C17.0597 18.031 18 17.091 18 15.961V14.2305C18 13.2105 17.2405 12.3603 16.2305 12.2403L13.7109 11.9493C13.1009 11.8793 12.5003 12.0896 12.0703 12.5196L10.2207 14.3692C8.80171 13.6492 7.51436 12.7107 6.40236 11.5977C5.28936 10.4857 4.35087 9.19836 3.63087 7.77936L5.48048 5.92975C5.91048 5.49975 6.12079 4.89912 6.05079 4.28912L5.75978 1.76959C5.63978 0.759592 4.78954 6.10352e-05 3.76954 6.10352e-05H2.03907ZM10 6.10352e-05C9.45001 6.10352e-05 9.00001 0.450061 9.00001 1.00006V8.50592C9.00001 8.94492 9.53081 9.16553 9.84181 8.85553L11.6953 7.00006H17C17.55 7.00006 18 6.55006 18 6.00006V1.00006C18 0.450061 17.55 6.10352e-05 17 6.10352e-05H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneTwilio);
export default __webpack_public_path__ + "static/media/phone-twilio.f4ad47b5b1b984b014d1397f8cee5f59.svg";
export { ForwardRef as ReactComponent };